<template>
  <div class="nav-bottom">
    <v-bottom-navigation grow>
      <v-btn href="tel:+27659698353">
        <v-icon>mdi-phone</v-icon>
      </v-btn>

      <v-btn href="mailto:alphyiago@gmail.com">
        <v-icon>mdi-email-outline</v-icon>
      </v-btn>

      <v-btn router to="/">
        <v-icon>mdi-home</v-icon>
      </v-btn>

      <v-btn @click="share">
        <v-icon>mdi-share-variant-outline</v-icon>
      </v-btn>

      <v-btn router to="/menu">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>
<script>
export default {
  methods: {
    async share() {
      if (navigator.canShare) {
        navigator.share({
          url: 'https://alphyiago.web.app',
          title: 'ALPHYIAGO',
          text: 'Premium',
        })
      }
    },
  },
}
</script>